import { type FC } from "react";
import PersonOff from "@mui/icons-material/PersonOff";

import { InfoPage } from "../../../shared/components/info-page/info-page";
import { InfoPageIllustration } from "../../../shared/components/info-page/info-page-illustration";
import { InfoPageLayout } from "../../../shared/components/info-page/info-page-layout";
import { SignInButton } from "../components/sign-in-button";
import { SignOutButton } from "../components/sign-out-button";

export const AccountNotConnectedPage: FC = () => (
  <InfoPageLayout>
    <InfoPage
      title="Учётная запись не подключена"
      message="Обратитесь к администратору, чтобы подключить её к EkoCrop"
      illustration={<InfoPageIllustration icon={PersonOff} />}
      actions={
        <>
          <SignOutButton />
          <SignInButton />
        </>
      }
    />
  </InfoPageLayout>
);
